import React from "react";
import { useCallback } from "react";
import Error from "../../../components/Error";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import Button from "../../../components/Button";
import { useAuth } from "../hooks/useAuth";
import Loading from "../../../components/Loading";
import { AdapterLink } from "../../../components/Adopter";

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    borderRadius: "50%",
    border: "2px solid",
    borderColor: "inherit",
    paddingTop: 15,
    height: 70,
    width: 70,
  },
  textContainer: {
    display: "block",
    width: "100%",
    marginTop: 50,
    marginBottom: 20,
  },
}));
export default function VerifyPage() {
  const classes = useStyles();

  const {
    user,
    data: { verifying },
    actions: { sendVerificationEmail },
  } = useAuth();

  const handleClick = useCallback(
    () => sendVerificationEmail(user.email),
    [user],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {verifying && <Loading />}
      <Error icon={"plane"} iconProps={{ className: classes.icon }}>
        Please check your email
        <Typography variant={"caption"} className={classes.textContainer}>
          If you're having a problem with email please{" "}
          <AdapterLink href="mailto:support@worlded.us">
            contact support
          </AdapterLink>
          .
        </Typography>
        <TextDivider text={"OR"} />
        <Button variant={"outlined"} onClick={handleClick} color={"primary"}>
          Send again
        </Button>
      </Error>
    </>
  );
}
